import { render, staticRenderFns } from "./ModuleSettingsTableComponent.vue?vue&type=template&id=b2eab5d0&scoped=true"
import script from "./ModuleSettingsTableComponent.vue?vue&type=script&lang=js"
export * from "./ModuleSettingsTableComponent.vue?vue&type=script&lang=js"
import style0 from "./ModuleSettingsTableComponent.vue?vue&type=style&index=0&id=b2eab5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eab5d0",
  null
  
)

export default component.exports